import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ExamenDefinitionDataService} from './impl/service/ngrx/examenDefinitionData.service';
import {ExamenDefinitionConverter} from './api/entity/converter/examenDefinition.converter';
import {ExamenDefinitionRepository} from './impl/service/ngrx/examenDefinition.repository';
import {ExamenDefinitionSummaryConverter} from './api/entity/converter/examenDefinitionSummary.converter';
import {ExamenDefinitionDataServiceAdapter} from './impl/service/ngrx/examenDefinitionDataService.adapter';
import {
    ExamenDefinitionSummaryDataServiceAdapter
} from './impl/service/ngrx/examenDefinitionSummaryDataService.adapter';
import {
    FormDefinitionFormConverter
} from '../../form/definition/form/api/entity/converter/formDefinitionForm.converter';
import {
    ExamFormDefinitionFormValueJsonHandlerComponent
} from './impl/component/exam-form-definition-form-value-json-handler/exam-form-definition-form-value-json-handler.component';
import {
    ExamFormDefinitionFormValueJsonHandlerModule
} from './impl/component/exam-form-definition-form-value-json-handler/exam-form-definition-form-value-json-handler.module';
import {
    FieldInputTypeHandlerRegister
} from '../../../components/common/field/field-input/type-handler/IFieldInputTypeHandler';
import {FormDefinitionFieldType} from '../../form/definition/field/api/entity/formDefinitionFieldSummary.model';

@NgModule({
    providers: [
        ExamenDefinitionDataService,
        ExamenDefinitionSummaryDataServiceAdapter,
        ExamenDefinitionDataServiceAdapter,
        ExamenDefinitionRepository,
        FormDefinitionFormConverter,
    ],
    imports: [
        ExamFormDefinitionFormValueJsonHandlerModule
    ]
})
export class ExamenDefinitionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: ExamenDefinitionDataService,
                service: ExamenDefinitionRepository,
    ) {

        entityDataService.registerServices({
            ExamenDefinition: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ExamenDefinition: service,
        });

        FieldInputTypeHandlerRegister.register(ExamFormDefinitionFormValueJsonHandlerComponent,
            FormDefinitionFieldType.FORM_DEFINITION_FIELD_TYPE_JSON,
            'FORM_DEFINITION_FIELD_SUBTYPE_EXAM_FORM_DEFINITION_NAME');
    }
}
